import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Constants } from "../../../constants";

@Injectable({
    providedIn: "root",
})
export default class DisplaySizeService {
    usingMobile: Boolean = false;
    isMobile: Boolean = false;

    constructor(private router: Router) {
        if (Constants.isMobile()) {
            this.isMobile = true;
            if (localStorage.getItem("DesktopView")) {
                this.usingMobile = localStorage.getItem("DesktopView") == "Mobile";
            } else {
                this.usingMobile = true;
                localStorage.setItem("DesktopView", "Mobile");
            }
        } else {
            // desktop setup
            this.isMobile = false;
            localStorage.removeItem("DesktopView");

            // if on mobile but requesting desktop site
            if (screen.width < 960) {
                let viewport = document.querySelector('meta[name="viewport"]');
                viewport.setAttribute("content", "width=1024");
            }
        }
        this.setView();
    }

    setView() {
        var viewMode = localStorage.getItem("DesktopView");
        let viewport = document.querySelector('meta[name="viewport"]');
        if (viewMode == "Desktop") {
            viewport.setAttribute("content", "width=1024");
        } else if (viewMode == "Mobile") {
            viewport.setAttribute("content", "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no");
        }
    }

    mobileToggle() {
        this.usingMobile = !this.usingMobile;
        localStorage.setItem("DesktopView", this.usingMobile ? "Mobile" : "Desktop");
        this.usingMobile ? this.router.navigate(["/mobile"]) : this.router.navigate(["/"]);
        this.setView();
    }
}
